module.exports = __webpack_public_path__ + "static/media/Monday_Step1_Image13.8427a0dd.webp";